import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const CustomSwitch = styled(Switch)(() => ({
  width: 57,
  height: 40,
  padding: 9,
  "& .MuiSwitch-switchBase": {
    margin: 9,
    padding: 1.3,
    transform: "translateX(1px)",  // Adjusted to fit within the padding and margin
    "&.Mui-checked": {
      color: "#fff",  // Ensures the color of the knob icon (if any)
      transform: "translateX(17px)",  // Adjusted for proper sliding
      "& + .MuiSwitch-track": {
        backgroundColor: "#0000a0",  // Dark blue background when ON
        opacity: 1,  // Ensures full color visibility
      },
      "& .MuiSwitch-thumb": {
        backgroundColor: "#00d7b9", // Cyan color for the thumb when ON
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#0000a0", // Dark blue for the thumb when OFF
    width: 19,
    height: 19,
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    backgroundColor: "#FFFFFF", // White track background when OFF
    opacity: 1,  // Ensures full color visibility
    border: "1px solid #0000a0", // Dark blue border when OFF
  },
}));

export default CustomSwitch;
